import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Input from '../../../components/abstractObjects/Input';
import { selectVarById, updateIsAllAboveInformationCorrect } from '../../var/varSlice'
import { Label, SectionLabel } from '../../../components/abstractObjects/Label'
import { RadioYesNoNull } from '../../../components/abstractObjects/RadioYesNo'
import { CheckBox } from '../../../components/abstractObjects/CheckBox'
import { VarPoLineForm } from '../../varPoLines/varPoLineForm'
import { ExpandableObject } from '../../../components/abstractObjects/ExpandableObject';


export const QuestionnaireInfoCorrectForm = ({ varId }) => {
    const varx = useSelector((state) => selectVarById(state, varId))

    const [IsAllAboveInformationCorrect, setIsAllAboveInformationCorrect] = useState({ value: varx.IsAllAboveInformationCorrect, error: null })
    const [AirportOfDestinationIncorrect, setAirportOfDestinationIncorrect] = useState({ value: varx.AirportOfDestinationIncorrect, error: null })
    const [AirportOfDestinationCorrected, setAirportOfDestinationCorrected] = useState({ value: varx.AirportOfDestinationCorrected, error: null })
    const [PonoIncorrect, setPonoIncorrect] = useState({ value: varx.PonoIncorrect, error: null })
    const [PonoCorrected, setPonoCorrected] = useState({ value: varx.PonoCorrected, error: null })
    const [AwbNoIncorrect, setAwbNoIncorrect] = useState({ value: varx.AwbNoIncorrect, error: null })
    const [AwbNoCorrected, setAwbNoCorrected] = useState({ value: varx.AwbNoCorrected, error: null })
    const [DeliveryInformationIncorrect, setDeliveryInformationIncorrect] = useState({ value: varx.DeliveryInformationIncorrect, error: null })
    const [AllAboveInformationCorrectComment, setAllAboveInformationCorrectComment] = useState({ value: varx.AllAboveInformationCorrectComment, error: null })

    const onIsAllAboveInformationCorrectChanged = (_, value) => {
        setIsAllAboveInformationCorrect({ value: value == 'true' })
        if (value == 'true') {
            setAirportOfDestinationIncorrect({ value: null })
            setAirportOfDestinationCorrected({ value: null })
            setPonoIncorrect({ value: null })
            setPonoCorrected({ value: null })
            setAwbNoIncorrect({ value: null })
            setAwbNoCorrected({ value: null })
        }
        updateQuestion1({ IsAllAboveInformationCorrectValue: value == 'true' })
    }
    const onAirportOfDestinationIncorrectChanged = (_, value) => {
        setAirportOfDestinationIncorrect({ value: value == true })
        if (value == false) setAirportOfDestinationCorrected({ value: null })
        updateQuestion1({ AirportOfDestinationIncorrectValue: value == true, AirportOfDestinationCorrectedValue: null })
    }
    const onAirportOfDestinationCorrectedChanged = (e) => {
        setAirportOfDestinationCorrected({ value: e.target.value })
        updateQuestion1({ AirportOfDestinationCorrectedValue: e.target.value })
    }
    const onPonoIncorrectChanged = (_, value) => {
        setPonoIncorrect({ value: value == true })
        if (value == false) setPonoCorrected({ value: null })
        updateQuestion1({ PonoIncorrectValue: value == true, PonoCorrectedValue: null })
    }
    const onPonoCorrectedChanged = (e) => {
        setPonoCorrected({ value: e.target.value })
        updateQuestion1({ PonoCorrectedValue: e.target.value })
    }
    const onAwbNoIncorrectChanged = (_, value) => {
        setAwbNoIncorrect({ value: value == true })
        if (value == false) setAwbNoCorrected({ value: null })
        updateQuestion1({ AwbNoIncorrectValue: value == true, AwbNoCorrectedValue: null })
    }
    const onAwbNoCorrectedChanged = (e) => {
        setAwbNoCorrected({ value: e.target.value })
        updateQuestion1({ AwbNoCorrectedValue: e.target.value })
    }
    const onDeliveryInformationIncorrectChanged = (_, value) => {
        setDeliveryInformationIncorrect({ value: value == true })
        updateQuestion1({ DeliveryInformationIncorrectValue: value == true })
    }
    const onAllAboveInformationCorrectCommentChanged = (e) => {
        setAllAboveInformationCorrectComment({ value: e.target.value, error: null })
        updateQuestion1({ AllAboveInformationCorrectCommentValue: e.target.value })
    }

    //EXPANDABLE
    const [expandVarPoLines, setExpandVarPoLines] = useState(true)

    //QUESTIONS
    var arrUiVarPoLines = [], arrUpdateObjs = [];
    varx.VarPoLines.map((object) => {
        var [uiVarPoLines, updateObjs] = VarPoLineForm(object, varx.ImSupervisor)
        arrUiVarPoLines.push(uiVarPoLines)
        arrUpdateObjs.push(updateObjs)
    })

    const dispatch = useDispatch()

    const updateQuestion1 = ({ IsAllAboveInformationCorrectValue, AirportOfDestinationIncorrectValue, AirportOfDestinationCorrectedValue, PonoIncorrectValue,
        PonoCorrectedValue, AwbNoIncorrectValue, AwbNoCorrectedValue, DeliveryInformationIncorrectValue, AllAboveInformationCorrectCommentValue } = {}) => {
        dispatch(
            updateIsAllAboveInformationCorrect({
                VarTransactionId: varId,
                IsAllAboveInformationCorrect: IsAllAboveInformationCorrectValue ?? IsAllAboveInformationCorrect.value,
                AirportOfDestinationIncorrect: AirportOfDestinationIncorrectValue ?? AirportOfDestinationIncorrect.value,
                AirportOfDestinationCorrected: AirportOfDestinationCorrectedValue ?? AirportOfDestinationCorrected.value,
                PonoIncorrect: PonoIncorrectValue ?? PonoIncorrect.value,
                PonoCorrected: PonoCorrectedValue ?? PonoCorrected.value,
                AwbNoIncorrect: AwbNoIncorrectValue ?? AwbNoIncorrect.value,
                AwbNoCorrected: AwbNoCorrectedValue ?? AwbNoCorrected.value,
                DeliveryInformationIncorrect: DeliveryInformationIncorrectValue ?? DeliveryInformationIncorrect.value,
                AllAboveInformationCorrectComment: AllAboveInformationCorrectCommentValue ?? AllAboveInformationCorrectComment.value,
            })
        )
    }

    const updateObj = () => {
        var validation = true
        if (IsAllAboveInformationCorrect.value == null) {
            setIsAllAboveInformationCorrect({ error: "Required!" })
            validation = false
        }
        if (validation === false) return false
        updateQuestion1()
        if (DeliveryInformationIncorrect.value != true) return validation
        arrUpdateObjs.forEach(updatePoLineObj => {
            if (!updatePoLineObj())
                validation = false
        })
        return validation
    }

    const questionnaireInfoCorrectForm = (
        <React.Fragment>
            <SectionLabel text="QUESTION_1" />
            <RadioYesNoNull text="LABEL_1" value={IsAllAboveInformationCorrect.value} error={IsAllAboveInformationCorrect.error} aria-label="IsAllAboveInformationCorrect" onChange={onIsAllAboveInformationCorrectChanged} readonly={varx.ImSupervisor} />
            {IsAllAboveInformationCorrect.value == false ? (
                <React.Fragment>
                    <Label text="LABEL_1_2" style={{ fontWeight: "bold" }} /><br /><br />
                    <CheckBox style={{ paddingRight: "10px" }} value={AirportOfDestinationIncorrect.value} error={AirportOfDestinationIncorrect.error} aria-label="AirportOfDestinationIncorrect" onChange={onAirportOfDestinationIncorrectChanged} disabled={varx.ImSupervisor} /><Label text="AIRPORT_OF_DESTINATION" />
                    {AirportOfDestinationIncorrect.value ? <React.Fragment>&nbsp;&nbsp;<Input style={{ width: '50%', minWidth: '245px' }} value={AirportOfDestinationCorrected.value ? AirportOfDestinationCorrected.value : ''} error={AirportOfDestinationCorrected.error} aria-label="AirportOfDestinationCorrected" onChange={onAirportOfDestinationCorrectedChanged} readonly={varx.ImSupervisor} /></React.Fragment> : null}<br />
                    <CheckBox style={{ paddingRight: "10px" }} value={PonoIncorrect.value} error={PonoIncorrect.error} aria-label="PonoIncorrect" onChange={onPonoIncorrectChanged} disabled={varx.ImSupervisor} /><Label text="PO_NUMBER" />
                    {PonoIncorrect.value ? <React.Fragment>&nbsp;&nbsp;<Input style={{ width: '50%', minWidth: '245px' }} value={PonoCorrected.value ? PonoCorrected.value : ''} error={PonoCorrected.error} aria-label="PonoCorrected" onChange={onPonoCorrectedChanged} readonly={varx.ImSupervisor} /></React.Fragment> : null}<br />
                    <CheckBox style={{ paddingRight: "10px" }} value={AwbNoIncorrect.value} error={AwbNoIncorrect.error} aria-label="AwbNoIncorrect" onChange={onAwbNoIncorrectChanged} disabled={varx.ImSupervisor} /><Label text="AWB No" />
                    {AwbNoIncorrect.value ? <React.Fragment>&nbsp;&nbsp;<Input style={{ width: '50%', minWidth: '245px' }} value={AwbNoCorrected.value ? AwbNoCorrected.value : ''} error={AwbNoCorrected.error} aria-label="AwbNoCorrected" onChange={onAwbNoCorrectedChanged} readonly={varx.ImSupervisor} /></React.Fragment> : null}<br />
                    <CheckBox style={{ paddingRight: "10px" }} value={DeliveryInformationIncorrect.value} error={DeliveryInformationIncorrect.error} aria-label="DeliveryInformationIncorrect" onChange={onDeliveryInformationIncorrectChanged} disabled={varx.ImSupervisor} /><Label text="DELIVERY_INFORMATION" /><br /><br />
                    {DeliveryInformationIncorrect.value ?
                        <ExpandableObject class="secondaryExpandable" name="DELIVERY_INFORMATION" onChange={() => setExpandVarPoLines(!expandVarPoLines)} expanded={expandVarPoLines}>
                            {arrUiVarPoLines.map(x => x)}
                        </ExpandableObject> : null}
                    <Label text="COMMENT_LABEL" /><Input value={AllAboveInformationCorrectComment.value ? AllAboveInformationCorrectComment.value : ''} error={AllAboveInformationCorrectComment.error} aria-label="AllAboveInformationCorrectComment" onChange={onAllAboveInformationCorrectCommentChanged} readonly={varx.ImSupervisor} />
                </React.Fragment>
            ) : null}
        </React.Fragment>
    )
    return [questionnaireInfoCorrectForm, updateObj];
}

export default QuestionnaireInfoCorrectForm;